"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APLabelWithText = _interopRequireDefault(require("../../../common/APLabelWithText"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
require("../BuySellOrderOverview/BuySellOrderOverviewComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var classes = (0, _cssClassesHelper.getBEMClasses)('buy-sell-order-overview');
var EotcBuySellOrderOverviewComponent = function EotcBuySellOrderOverviewComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("order"),
    t = _useTranslation.t;
  var symbol1 = props.symbol1,
    symbol2 = props.symbol2,
    transactionCost = props.transactionCost,
    notEnoughMarket = props.notEnoughMarket,
    quantity = props.quantity,
    pricePerUnit = props.pricePerUnit,
    isBuySide = props.isBuySide,
    fee = props.fee,
    hideFees = props.hideFees,
    customClass = props.customClass;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(customClass || '', " ").concat(classes())
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "".concat(customClass || '', " ").concat(classes('title'))
  }, t("Transaction Overview")), notEnoughMarket ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('content')
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: classes('content')
  }, t("We cannot fill this request."))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('content')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    customClass: "".concat(customClass || '', " ").concat(classes()),
    label: isBuySide ? t("{{symbol1}} to Buy", {
      symbol1: symbol1
    }) : t("{{symbol1}} to Sell", {
      symbol1: symbol1
    }),
    text: quantity
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    name: "pricePerUnit",
    customClass: "".concat(customClass || '', " ").concat(classes()),
    label: t("Price"),
    text: t(pricePerUnit)
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    customClass: "".concat(customClass || '', " ").concat(classes()),
    label: t("Transaction Cost"),
    text: "".concat(transactionCost, " ").concat(symbol2)
  }), !hideFees && /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    name: "fee",
    customClass: "".concat(customClass, " ").concat(classes()),
    label: t("Fee"),
    text: fee
  })));
};
EotcBuySellOrderOverviewComponent.defaultProps = {
  displayPricePerUnit: false
};
EotcBuySellOrderOverviewComponent.propTypes = {
  symbol1: _propTypes["default"].string.isRequired,
  symbol2: _propTypes["default"].string.isRequired,
  transactionCost: _propTypes["default"].string.isRequired,
  notEnoughMarket: _propTypes["default"].bool.isRequired,
  quantity: _propTypes["default"].string.isRequired,
  pricePerUnit: _propTypes["default"].string.isRequired,
  isBuySide: _propTypes["default"].bool.isRequired,
  fee: _propTypes["default"].string.isRequired,
  hideFees: _propTypes["default"].bool.isRequired,
  displayPricePerUnit: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = EotcBuySellOrderOverviewComponent;